import { updatesData } from '@/mocks/home';

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">实时快讯</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">24小时滚动更新，不错过任何一个瓜</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updatesData.map((item, idx) => (
            <div key={item.id} className="flex gap-4 group cursor-pointer">
              <div className="flex flex-col items-center">
                <div className={`w-3 h-3 rounded-full border-2 shrink-0 mt-1.5 ${
                  item.tag === '最新' || item.tag === '突发'
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-background-100 border-secondary-400'
                }`}></div>
                {idx < updatesData.length - 1 && (
                  <div className="w-0.5 flex-1 bg-background-200/70 my-1 group-hover:bg-primary-200 transition-colors"></div>
                )}
              </div>
              <div className={`pb-6 ${idx === updatesData.length - 1 ? '' : ''}`}>
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                    item.tag === '最新' || item.tag === '突发'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '重磅'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h4 className="text-sm text-foreground-800 leading-relaxed group-hover:text-primary-600 transition-colors cursor-pointer">
                  {item.title}
                </h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}